<brightside-web-eligibility-check
  *ngIf="company"
  [showBackButton]="true"
  [emitBackButton]="true"
  [analyticName]="'verify_eligibility'"
  [analyticEventProps]="{'customer type': customerType, 'verification type': employmentType}"
  (identitySubmitted)="onIdentityComplete($event)"
  (backEmitted)="goBack(company)">
  <div title-copy>{{ titleKey | translate:{company:company|titlecase} }}</div>
  <div intro-paragraph>
    <bw-paragraph>
      {{ bodyKey | translate }}
    </bw-paragraph>
  </div>
</brightside-web-eligibility-check>
